import moment from "moment";

export const dateMoment = (dateString) => {
  return moment(dateString).utc().format("DD-MM-YYYY");
};
export const parseDate = (dateString) => {
  return moment(dateString).utc().format("DD-MM-YYYY");
};
